import glam from 'glamorous';
import { BrandonGrotesque } from 'module/View/Common';

export const LinksWrapper = glam.div({
  marginBottom: 20,
});

export const CategoryLinkWrapper = glam.a({
  color: 'inherit',
});

export const NextTextWrapper = glam.p({
  color: 'inherit',
  fontSize: '1.2rem',
  fontFamily: BrandonGrotesque.bold,
  fontStyle: 'normal',
  fontWeight: 'normal',
  marginBottom: '0.5rem',
});



// WEBPACK FOOTER //
// ./src/module/View/NextPosts/NextPosts.s.ts